<cm-dialog [id]="id"
  data-show-top-divider data-show-bottom-divider
  data-max-width="920px" data-max-height="480px">

  <div slot="header" class="dialog-title">
    <h3>{{('Dialog_File_Picker.File_Picker' | trans)}}</h3>

    <div class="tabs">
      <div class="tab" [class.active]="activeTab === 'UPLOADED_FILES'" (click)="onTabClicked('UPLOADED_FILES')">
        {{('Dialog_File_Picker.Uploaded_Files' | trans)}}
      </div>
      <div class="tab m-l-16" [class.active]="activeTab === 'FROM_COMPUTER'"
        (click)="onTabClicked('FROM_COMPUTER')">
        {{('Dialog_File_Picker.From_Computer' | trans)}}
      </div>
    </div>
  </div>

  <div slot="body" class="form-row">
    @if (isLoading) {
      <cm-indicator></cm-indicator>
    }

    @if (activeTab === 'UPLOADED_FILES') {
      <div class="row">
        @for (file of files; track fileTrackBy($index, file)) {
          <div class="col-3 image-preview text-center"
            [class.selected]="selectedFile && selectedFile.uuid === file.uuid"
            (click)="onFileClicked(file)">
            @switch (file.type) {
              @case ('IMAGE') {
                <img [src]="file.link" [alt]="file.name">
              }
              @case ('PDF') {
                <img src="https://www.cm.com/app/aurora/svg/icons/pdf.svg" alt="PDF Icon">
              }
            }
            <br>
              {{ file.name }}
            </div>
          }
        </div>
      }

      @if (activeTab === 'FROM_COMPUTER') {
        @if (!uploadedFile) {
          <div class="row m-t-32 m-b-32">
            <div class="col-12 col-md-6 offset-md-3">
              <cm-file-upload data-display="Upload file"
                data-max-file-size="4000000"
              (change)="onFileUploadSelected($event)"></cm-file-upload>
            </div>
          </div>
        }
        @if (uploadedFile) {
          <div class="row">
            <div class="col-6 offset-3 text-center">
              <h3>{{ uploadedFile.name }}</h3>
              <img [src]="uploadedFileBlob" [alt]="uploadedFile.name"><br>
              <button class="btn btn-secondary"
              (click)="onFileUploadUnsetClicked()">{{ 'Dialog_File_Picker.Change_File' | trans }}</button>
            </div>
          </div>
        }
      }
    </div>

    <div slot="footer">
      <button class="btn btn-secondary" (click)="cancel()">{{('General.Cancel' | trans)}}</button>
      @if (activeTab === 'UPLOADED_FILES') {
        <button class="btn btn-primary" (click)="confirmSelect()"
        [disabled]="!selectedFile">{{('General.Select' | trans)}}</button>
      }
      @if (activeTab === 'FROM_COMPUTER') {
        <button class="btn btn-primary"
          (click)="confirmUploadAndSelect()"
        [disabled]="!uploadedFile">{{('General.Upload' | trans)}}</button>
      }
    </div>

  </cm-dialog>
